var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "m13.202 11.5 6.039-7.199A.183.183 0 0 0 19.1 4h-1.836a.38.38 0 0 0-.284.131l-4.98 5.938L7.02 4.131A.37.37 0 0 0 6.737 4H4.9a.183.183 0 0 0-.14.301L10.8 11.5l-6.04 7.199a.183.183 0 0 0 .141.301h1.836a.38.38 0 0 0 .283-.131L12 12.93l4.982 5.938c.069.083.172.131.283.131H19.1a.183.183 0 0 0 .14-.301z"
  })));
};
export default SvgClose;